@import (reference) '../../../../../../constants/spacing.module.less';

.expected-date-column,
.cost-column {
  text-align: center;
}

.cost-column {
  text-align: center;
}

.progress-bar-small {
  height: 6px;
  width: 60px;
  background-color: var(--grey-400);
  border-radius: 3px;
  margin: @space-0 auto @space-4;
  overflow: hidden;
}

.progress-bar-inner-small {
  height: 100%;
  background-color: var(--green-600);
  border-radius: 3px;
}
